import { fullHeight, fullHeightContainer, isRealIOSDevice } from 'helpers/browser'

const BOTTOM_NAV_HEIGHT = 80
const BOTTOM_NAV_HEIGHT_M = 96

const NAVBAR_HEIGHT = 96
const NAVBAR_HEIGHT_M = 83

const MAX_GALLERY_HEIGHT = '650px'

export const getStyles = md => {
  let totalHeight

  if (md) {
    totalHeight = NAVBAR_HEIGHT + BOTTOM_NAV_HEIGHT
  } else {
    totalHeight = NAVBAR_HEIGHT_M + BOTTOM_NAV_HEIGHT_M
  }

  return {
    imageGallery: {
      height: isRealIOSDevice ? '-webkit-fill-available' : `calc(100vh - ${totalHeight}px)`,
      paddingBottom: isRealIOSDevice ? `${NAVBAR_HEIGHT_M}px` : 0,
      maxHeight: md ? MAX_GALLERY_HEIGHT : `calc(100vh - ${totalHeight}px)`,
    },
    profile: {
      ...fullHeight,
    },
    profileWrapper: {
      ...fullHeightContainer,
    },
  }
}
